import { useMemo } from 'react';
import { SuggestionCompanyPureType, useAutocompleteSuggestionCompanyLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import {
  AutocompleteSuggestionCompanyResultType,
  AutocompleteSuggestionCompanyInputType,
  UseAutocompleteSuggestionCompanyConfigType,
  UseAutocompleteSuggestionCompanyType,
  SuggestionCompanyType,
} from './types';

const getSuggestions = (value: SuggestionCompanyPureType[]): SuggestionCompanyType[] => {
  const suggestions = value.map((item) => ({
    inn: item.inn,
    bin: item.bin,
    unp: item.unp,
    address: item.address,
    city: item.city,
    fullName: item.fullName,
    kpp: item.kpp,
    management: item.management,
    name: item.name,
    ogrn: item.ogrn,
    organizationType: item.organizationType,
    region: item.region,
    shortName: item.shortName,
  }));

  // @ts-ignore
  return suggestions;
};

const useAutocompleteSuggestionCompany = (
  config?: UseAutocompleteSuggestionCompanyConfigType
): UseAutocompleteSuggestionCompanyType => {
  const [query, queryResult] = useAutocompleteSuggestionCompanyLazyQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_FIRST,
    onCompleted: (data) => {
      config?.onCompleted?.(getSuggestions(data.userPureSuggestionCompany.result || []));
    },
  });

  const request = async (input: AutocompleteSuggestionCompanyInputType) => {
    await query({
      variables: { input },
    });
  };

  const suggestionResult = queryResult.data?.userPureSuggestionCompany.result;

  const company = useMemo(() => getSuggestions(suggestionResult || []), [suggestionResult]);

  const result: AutocompleteSuggestionCompanyResultType = {
    error: queryResult.error,
    loading: queryResult.loading,
    data: { result: company },
  };

  return [request, result];
};

export default useAutocompleteSuggestionCompany;
